// These only contain Private keys
type EnvVariables = {
  INSTANT_APP_ID: string;
  INSTANT_API_KEY: string;
  BETTER_AUTH_SECRET: string;
  BETTER_AUTH_URL: string;
  // AI
  GROQ_API_KEY: string;
  OPENROUTER_API_KEY: string;
  OPENAI_API_KEY: string;
  BASETEN_API_KEY: string;
  REPLICATE_API_KEY: string;

  AUTH_GOOGLE_SECRET: string;
  AUTH_GOOGLE_ID: string;
  STRIPE_SECRET_KEY: string;
  STRIPE_FILEPROMPT_PRO: string;
  STRIPE_WEBHOOKS_ENDPOINT_SECRET: string;
  RESEND_API_KEY: string;
};

// On the server side, access environment variables
export const envVariables: EnvVariables = {
  INSTANT_APP_ID: process.env.INSTANT_APP_ID as string,
  INSTANT_API_KEY: process.env.INSTANT_API_KEY as string,
  BETTER_AUTH_SECRET: process.env.BETTER_AUTH_SECRET as string,
  BETTER_AUTH_URL: process.env.BETTER_AUTH_URL as string,
  // AI
  GROQ_API_KEY: process.env.GROQ_API_KEY as string,
  OPENROUTER_API_KEY: process.env.OPENROUTER_API_KEY as string,
  OPENAI_API_KEY: process.env.OPENAI_API_KEY as string,
  BASETEN_API_KEY: process.env.BASETEN_API_KEY as string,
  REPLICATE_API_KEY: process.env.REPLICATE_API_KEY as string,

  AUTH_GOOGLE_SECRET: process.env.AUTH_GOOGLE_SECRET as string,
  AUTH_GOOGLE_ID: process.env.AUTH_GOOGLE_ID as string,
  STRIPE_SECRET_KEY: process.env.STRIPE_SECRET_KEY as string,
  STRIPE_FILEPROMPT_PRO: process.env.STRIPE_FILEPROMPT_PRO as string,
  STRIPE_WEBHOOKS_ENDPOINT_SECRET: process.env.STRIPE_WEBHOOKS_ENDPOINT_SECRET as string,
  RESEND_API_KEY: process.env.RESEND_API_KEY as string,
};
